import { Section } from '../types';
import React from 'react';
import { SectionElement } from './element';
import { useMobile } from '../context/mobile/mobile.provider';
import classNames from 'classnames';

type Props = {
  sections: Section[];
};
function Sections({ sections }: Props) {
  const { isMobile } = useMobile();

  if (!sections) {
    return null;
  }
  return (
    <div
      className={classNames('core-page-sections w-full max-w-full flex flex-column ', {
        'gap-2': isMobile,
        'gap-8': !isMobile,
      })}
    >
      {sections.map((section, idx) => (
        <SectionElement key={`section_${idx}`} section={section} />
      ))}
    </div>
  );
}

export { Sections };
